import { Text } from '@factorialco/deprecated-design-system'
import { ProjectionKind, useDocumentsDataTable } from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import SignatureStatusTag from 'modules/documents/components/Documents/List/Item/SignatureStatusTag'

type DocumentsDataTableProjection = Parameters<typeof useDocumentsDataTable>[0][number]

const DEFAULT_NO_VALUE = '-'

const signatureStatusProjection: () => DocumentsDataTableProjection = () => ({
  identifier: 'signatureStatus',
  title: i18n.t('documents.employee.list.signature_status'),
  kind: ProjectionKind.Custom,
  template: '',
  render: ({ signatureStatus }) => (
    <Text size="200">
      {!signatureStatus ? DEFAULT_NO_VALUE : <SignatureStatusTag status={signatureStatus} />}
    </Text>
  ),
  colSpan: 1,
})

export default signatureStatusProjection
